import React from 'react';
import { Container } from 'reactstrap';

export default function NotFound() {
  return (
    <Container>
      <h2 className="text-center mt-5">404 Page Not Found</h2>
    </Container>
  )
}